import React, { FunctionComponent } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import {
  DrugAutocomplete,
  FocusableHeader,
  SimpleHeader,
} from "../../components";
import { useQueryParams, useTranslate } from "../../helpers";
import routes from "../../app/routes";
import { AutocompletePapDrug } from "../../@types";

const PapLandingPage: FunctionComponent<RouteComponentProps> = ({
  location,
  history,
  match,
}) => {
  const t = useTranslate();
  useQueryParams({ location, history, match });

  return (
    <div className="PapLandingPage">
      <div className="PapLandingPage__hero">
        <SimpleHeader noBorder={true} variation="dark" hideLogin={true} />
        <div className="PapLandingPage__heroContent">
          <FocusableHeader
            className="ds-text-heading--5xl ds-u-text-align--center"
            text={t("pap.landing.header")}
            ignoreFocus={false}
          />
          <div className="ds-u-measure--base mct-p1 ds-u-color--white ds-u-text-align--center ds-u-margin-top--2 ds-u-margin-bottom--7">
            {t("pap.landing.subheader")}
          </div>
        </div>
      </div>

      <div className="PapLandingPage__content">
        <div className="ds-u-display--flex ds-u-justify-content--center ds-u-padding-x--2 ds-u-padding-bottom--3">
          <div className="m-c-card">
            <DrugAutocomplete
              className="ds-u-margin--2 ds-u-md-margin-y--5 ds-u-md-margin-x--7"
              onSelectDrug={selectedDrug => {
                history.push(
                  `${routes.pap.plans.replace(
                    ":drug",
                    (selectedDrug as AutocompletePapDrug).id
                  )}${location.search}`
                );
              }}
              PAP
              submitButtonText={t("pap.see_programs")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(PapLandingPage);
